export default __webpack_public_path__ + "static/media/social-reddit.ecbd521f.svg";